module.exports = __webpack_public_path__ + "static/media/ANDATTI_black.35003359.svg";